var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tmp-item"},[_c('div',{staticClass:"tmp-item-icon"},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"tmp-item-text"},[_vm._v(" "+_vm._s(_vm.cnName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }